import VatSummaryModelBase from '../_generated/modelBases/vat-summary-model-base';

export default class VatSummaryModel extends VatSummaryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
